import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["container", "template", "item"]
  static values = {
    placeholder: String,
    itemSelector: String
  }

  connect() {
    if (this.containerTarget.children.length === 0) {
      this.addField()
    }
  }

  addField(event) {
    if (event) event.preventDefault()

    const index = this.nextIndex()
    const placeholder = this.placeholderValue || 'NEW_ITEM'
    const html = this.templateTarget.innerHTML.replace(new RegExp(placeholder, 'g'), index)
    this.containerTarget.insertAdjacentHTML("beforeend", html)
  }

  removeField(event) {
    event.preventDefault()
    const selector = this.itemSelectorValue || `[data-${this.identifier}-target='item']`
    const item = event.target.closest(selector)
    if (item) item.remove()
  }

  nextIndex() {
    const selector = this.itemSelectorValue || `[data-${this.identifier}-target='item']`
    return this.containerTarget.querySelectorAll(selector).length
  }
}
